// extracted by mini-css-extract-plugin
module.exports = {"TopQueriesTable":"TopQueriesTable_T8Bum"};